import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { slackLinkQueryKeys } from "./slackQueryKeys";

/**
 * Spend a pending link, binding its Slack account to the signed-in Roboto user.
 *
 * The Roboto side is the caller's session, so this takes only the nonce.
 */
export function useClaimSlackLink() {
  const { slackService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (nonce: string) => slackService.claimLink(nonce),
    onSuccess: (_data, nonce) => {
      // The nonce is spent; its cached display describes something that no longer exists, and
      // refetching it would only 404.
      queryClient.removeQueries({ queryKey: slackLinkQueryKeys.nonce(nonce) });
    },
  });
}
